// extracted by mini-css-extract-plugin
module.exports = {"component":"RelicDrawSimulator_component__1dZn0","slideRelicsFromTop":"RelicDrawSimulator_slideRelicsFromTop__3S5Ue"};